import React from 'react';

const SvgCircleApps = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M5 3a2 2 0 10-.001 3.999A2 2 0 005 3zm7 0a2 2 0 10-.001 3.999A2 2 0 0012 3zm7 0a2 2 0 10-.001 3.999A2 2 0 0019 3zM5 10a2 2 0 10-.001 3.999A2 2 0 005 10zm7 0a2 2 0 10-.001 3.999A2 2 0 0012 10zm7 0a2 2 0 10-.001 3.999A2 2 0 0019 10zM5 17a2 2 0 10-.001 3.999A2 2 0 005 17zm7 0a2 2 0 10-.001 3.999A2 2 0 0012 17zm7 0a2 2 0 10-.001 3.999A2 2 0 0019 17z" />
  </svg>
);

export default SvgCircleApps;
